










import Vue from 'vue';

export default Vue.extend({
  name: 'GToChatListButton',
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
});
